import axios from 'axios'
import { isNil, get } from 'lodash'
import client from '../../client'

import {
  CREATE_IMPORT,
  RECEIVE_IMPORT,
  RECEIVE_ERROR,
  RESET_REQUEST
} from './consts'

const cancelToken = axios.CancelToken.source()

function parseErrors(errors) {
  let generalError
  const resourceErrors = get(errors, 'response.data.errors')

  if (isNil(resourceErrors)) { generalError = get(errors, 'response.data.error') }

  return { generalError, resourceErrors: resourceErrors || errors.response.data }
}

function createImport(attributes) {
  return (dispatch) => {
    dispatch({ type: CREATE_IMPORT, ...attributes })

    const config = {
      cancelToken: cancelToken.token
    }

    client.post('/census_imports', attributes, config)
      .then((response) => {
        return dispatch({
          type: RECEIVE_IMPORT,
          responseAttributes: response.data,
          responseHeaders: response.headers
        })
      })
      .catch((errors) => dispatch({ type: RECEIVE_ERROR, ...parseErrors(errors) }))
      .finally(() => axios.isCancel() && cancelToken.cancel())
  }
}

function resetImport() {
  return (dispatch) => {
    dispatch({ type: RESET_REQUEST })
  }
}

export { createImport, resetImport }
